

import React, { useRef, useState, useContext, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { classNames } from 'primereact/utils';
import { Checkbox } from 'primereact/checkbox';
import { ColorPicker } from 'primereact/colorpicker';

import axios from '../axios';
import { useFormik } from 'formik';
import AppContext from '../Context/AppContext';
import Modal from '../Widgets/Modal';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { useMountEffect } from 'primereact/hooks';
import { InputNumber } from 'primereact/inputnumber';
import ClosableCalendar from '../Widgets/ClosableCalendar';
import SignatureCanvas from 'react-signature-canvas';
import { FileUpload } from 'primereact/fileupload';

import moment from 'moment'

const ReportAddModal = ({ hide, update }) => {
    const existingNames = useRef([])
    const { sendMessage, toast, setBlocked } = useContext(AppContext)

    const [visible, setVisible] = useState(true)

    const sigCanvas = useRef(null);
    const [canvasWidth, setCanvasWidth] = useState(0);

    useEffect(() => {
        const updateCanvasWidth = () => {
            if (sigCanvas.current) {
                setCanvasWidth(sigCanvas.current.getCanvas().offsetWidth);
                //sigCanvas.current.clear()
                //console.log("Set canvas Width!", sigCanvas.current.parent())
            }
        };
        // Initial update
        updateCanvasWidth();
        // Update on window resize
        window.addEventListener('resize', updateCanvasWidth);
        return () => {
            window.removeEventListener('resize', updateCanvasWidth);
        };
    }, [sigCanvas]);

    const weather_condition = [
        "Sunny",
        "Overcast",
        "Rain",
        "Sleet",
        "Snow",
        "Ice",
        "Hail",
        "Strong Winds"
    ];

    const formik = useFormik({
        initialValues: {
            officers: "",
            location: "GREATER GRACE WORLD OUTREACH",
            date: new Date(),
            shift_start_time: null,
            shift_end_time: null,
            weather_condition: "Sunny",
            entries: []
        },
        validate: (data) => {
            let errors = {};
            /*if (!data.name) {
                errors.name = 'Name is required';
            }
            else if (data.name.length < 2) {
                errors.name = 'Name must have at least 2 letters'
            }
            else if (data.name.length > 15) {
                errors.name = 'Name must be not longer than 15 letters'
            }
            else if (existingNames.current.some(item => item.toLowerCase() === data.name.toLowerCase())) {
                errors.name = 'Name already exists in the database'
            }*/

            return errors;
        },
        onSubmit: async (data) => {
            setBlocked(true)
            /*try {
                const response = await axios.get('/codes/check', { params: { name: data.name } });
                if (response.data.success) {
                    existingNames.current = [...existingNames.current, ...response.data.data]
                    formik.validateForm()
                    setBlocked(false)
                    return
                }
            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to connect!', life: 3000 });
                setBlocked(false)
                return
            }*/
            data.date = data.date ? moment(data.date).format('DD MMMM YYYY').toString() : null;
            data.shift_start_time = data.shift_start_time ? moment(data.shift_start_time).format('hh:mm A').toString() : null;
            data.shift_end_time = data.shift_end_time ? moment(data.shift_end_time).format('hh:mm A').toString() : null;

            /*data.entries = data.entries.map(item => ({
                time: item.time ? moment(item.time).format('hh:mm A').toString() : null,
                activity: item.activity,
                file: 
            }))*/

            data.entries = await Promise.all(data.entries.map((item) => {
                return new Promise(async (resolve, reject) => {
                    if(item.file){
                        const reader = new FileReader();
                        let blob = await fetch(item.file.objectURL).then((r) => r.blob());
    
                        reader.readAsDataURL(blob);
                        reader.onloadend = async () => {
                            resolve({
                                time: item.time ? moment(item.time).format('hh:mm A').toString() : null,
                                activity: item.activity,
                                file: reader.result
                            })
                        }
                    }
                    else {
                        resolve({
                            time: item.time ? moment(item.time).format('hh:mm A').toString() : null,
                            activity: item.activity,
                            file: null
                        })
                    }
                }
            )}))

            setCurrentColor(sigCanvas.current.getCanvas(), 'black')
            const dataUrl = sigCanvas.current.getCanvas().toDataURL("image/png");

            data.signature = dataUrl

            try {
                const response = await axios.post('/reports/add', data);
                if (response.data.success) {
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: `Report added!`, life: 3000 });
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to add report!', life: 3000 });
                }
            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to add report!', life: 3000 });
            }

            setBlocked(false)
            update()
            sendMessage(JSON.stringify({ type: "reports_added" }))
            setVisible(false)
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const footer = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" outlined onClick={() => { setVisible(false) }} />
            <Button label="Save" icon="pi pi-check" className="m-0" type='submit' form='submit-report' />
        </React.Fragment>
    );

    function setCurrentColor(canvas, color) {
        var context = canvas.getContext('2d');
        context.save();
        context.fillStyle = color;
        context.globalCompositeOperation = 'source-in';
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.restore();
    }

    return (
        <Modal header="Add Report" visible={visible} onHide={() => setVisible(false)} transitionOptions={{ onExited: () => hide() }} footer={footer}>
            <form onSubmit={formik.handleSubmit} id='submit-report' className='formgrid grid'>
                <div className="field col-12">
                    <label htmlFor="officers">Officer(s)</label>
                    <InputText name='officers' id='officers' value={formik.values.officers} onChange={formik.handleChange} className={classNames('w-full', { 'p-invalid': isFormFieldValid('officers') })} autoFocus />
                    {getFormErrorMessage('officers')}
                </div>

                <div className="field col-12">
                    <label htmlFor="location">Location</label>
                    <InputText name='location' id='location' value={formik.values.location} onChange={formik.handleChange} className={classNames('w-full', { 'p-invalid': isFormFieldValid('location') })} readOnly />
                    {getFormErrorMessage('location')}
                </div>

                <div className="field col-12">
                    <label htmlFor="date">Date</label>
                    <ClosableCalendar name='date' inputId='date' value={formik.values.date} onChange={formik.handleChange} dateFormat='dd MM yy' className={classNames('w-full', { 'p-invalid': isFormFieldValid('date') })} readOnly />
                    {getFormErrorMessage('date')}
                </div>

                <div className="field col-12">
                    <label htmlFor="shift_start_time">Shift </label>
                    <div className='flex gap-3'>
                        <div className='flex-1'>
                            <ClosableCalendar name='shift_start_time' inputId="shift_start_time" value={formik.values.shift_start_time} onChange={formik.handleChange} timeOnly hourFormat="12" className={classNames('w-full', { 'p-invalid': isFormFieldValid('shift_start_time') })} />
                            {getFormErrorMessage('shift_start_time')}
                        </div>
                        <div className='flex-1'>
                            <ClosableCalendar name='shift_end_time' inputId="shift_end_time" value={formik.values.shift_end_time} onChange={formik.handleChange} timeOnly hourFormat="12" className={classNames('w-full', { 'p-invalid': isFormFieldValid('shift_end_time') })} />
                            {getFormErrorMessage('shift_end_time')}
                        </div>
                    </div>
                </div>

                <div className="field col-12">
                    <label htmlFor="weather_condition">Weather Condition</label>
                    <Dropdown inputId={`weather_condition`} name={`weather_condition`} value={formik.values.weather_condition} onChange={formik.handleChange} options={weather_condition} className={classNames('w-full', { 'p-invalid': isFormFieldValid('weather_condition') })} />
                    {getFormErrorMessage('weather_condition')}
                </div>

                {formik.values.entries.map((entry, index) => (
                    <div className="col-12" key={index}>
                        <div className='field'>
                            <label htmlFor={`entries.${index}.time`}>Entry {index + 1} Time</label>
                            <ClosableCalendar name={`entries.${index}.time`} inputId={`entries.${index}.time`} value={formik.values.entries[index].time} onChange={formik.handleChange} timeOnly hourFormat="12" className={classNames('w-full', { 'p-invalid': isFormFieldValid(`entries.${index}.time`) })} />
                            {getFormErrorMessage(`entries.${index}.time`)}
                        </div>
                        <div className='field'>
                            <label htmlFor={`entries.${index}.activity`}>Entry {index + 1} Activity</label>
                            <InputTextarea rows={3} name={`entries.${index}.activity`} id={`entries.${index}.activity`} value={formik.values.entries[index].activity} onChange={formik.handleChange} className={classNames('w-full', { 'p-invalid': isFormFieldValid(`entries.${index}.activity`) })} />
                            {getFormErrorMessage(`entries.${index}.activity`)}
                        </div>
                        <div className='field'>
                            <label htmlFor={`entries.${index}.attachments`}>Entry {index + 1} Attachments</label>
                            <FileUpload mode="basic" accept="image/jpeg, image/png, image/webp, image/svg+xml" customUpload onSelect={(e) => {formik.setFieldValue(`entries.${index}.file`, e.files[0])}}/>
                        </div>
                    </div>
                ))}

                <Button className='ml-2 mb-3' label="Add Entry" outlined type='button' onClick={() => { formik.setFieldValue('entries', [...formik.values.entries, { time: null, activity: "", file: null }]) }} />

                <div className="field col-12 mb-1">
                    <label htmlFor={`signature`}>Signature</label>
                    <SignatureCanvas
                        ref={sigCanvas}
                        canvasProps={{ width: canvasWidth, height: 250, className: 'border-round surface-ground', style: { border: "1px solid #424b57", width: "100%" } }}
                        penColor="white"
                    />
                </div>

                <Button className='ml-2 mb-3' label="Clear" outlined type='button' onClick={() => { sigCanvas.current.clear() }} />
            </form>
        </Modal>
    );
}

export default ReportAddModal;